import {useState, useEffect} from 'react';
import {get} from '../helpers/fetch.js';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import Looks4Icon from '@mui/icons-material/Looks4';
import Looks5Icon from '@mui/icons-material/Looks5';
import DoneIcon from '@mui/icons-material/Done';
import DeleteIcon from '@mui/icons-material/Delete';
import TimerOffIcon from '@mui/icons-material/TimerOff';
import Entry from './entry.js';
import * as tree from '@ecadem/tree';
import FolderIcon from '@mui/icons-material/Folder';
import {useBool} from '@ecadem/react-hooks';
import { Rectangle } from '@mui/icons-material';

function Settings () {
  const [settings, setSettings] = useState(null);

  async function load () {
    let url = '/settings/get';
    let res = await get(url);
    setSettings(res);
  }

  useEffect(() => {
    load();
  }, []);

  return (!settings ? <div>loading...</div> :
    <div style={{height:'14vh', minHeight:'14vh', padding:0}}>
      App settings: {JSON.stringify(settings)}
    </div>
  );
}

function Import ({importTarget, pickImportTarget, importText, setImportText, importPri, setImportPri, setShowingShortcuts}) {
  const [pending, setPending] = useState(false);

  async function doImport () {
    if (!importTarget) {
      alert('you did not pick an import target');
      return;
    }
    setPending(true);
    let url = '/entry/importtext/';
    url += '?text=' + encodeURIComponent(importText);
    url += '&parent=' + (importTarget ? importTarget.id : 'null');
    url += '&pri=' + (importPri ? importPri : 'null');
    await get(url);
    setPending(false);
    setImportText('');
  }

  return (pending ? <div>importing...</div> :
    <div style={{height:'14vh', minHeight:'14vh', padding:0}}>
      <textarea cols="200" rows="7" onChange={e => setImportText(e.target.value)}>{importText}</textarea>
      <br />
      <button onClick={doImport}>Import</button>
      <button style={{marginLeft:'20px', marginRight:'20px'}} onClick={pickImportTarget}>Pick Target {!importTarget ? null : (' (currently ' + importTarget.name + ')')}</button>
      <button onClick={() => setImportPri(1)} style={{marginLeft:'10px', backgroundColor:(importPri === 1 ? 'green' : 'lightgray')}}> 1 </button>
      <button onClick={() => setImportPri(2)} style={{marginLeft:'10px', backgroundColor:(importPri === 2 ? 'green' : 'lightgray')}}> 2 </button>
      <button onClick={() => setImportPri(3)} style={{marginLeft:'10px', backgroundColor:(importPri === 3 ? 'green' : 'lightgray')}}> 3 </button>
      <button onClick={() => setImportPri(4)} style={{marginLeft:'10px', backgroundColor:(importPri === 4 ? 'green' : 'lightgray')}}> 4 </button>
      <button onClick={() => setImportPri(5)} style={{marginLeft:'10px', backgroundColor:(importPri === 5 ? 'green' : 'lightgray')}}> 5 </button>
      <button onClick={() => setImportPri(null)} style={{marginLeft:'10px', backgroundColor:(importPri === null ? 'green' : 'lightgray')}}> x </button>

      <button onClick={setShowingShortcuts} style={{marginLeft:'50px', backgroundColor:'lightgray'}}> shortcuts </button>

    </div>
  );
}

function clone (obj) {
    return (JSON.parse(JSON.stringify(obj)));
}

function SearchBar ({search, editSearch, clearSearch}) {
  return (
      <div style={{marginBottom:'2px', height:'14vh', minHeight:'14vh', padding:0}}>
        Search (f, cmd-f): {search}
        <span className="searchBtns">
          <button onClick={() => editSearch(search)} style={{marginLeft:'10px'}}>Search</button>
          <button onClick={clearSearch} style={{marginLeft:'10px'}}>Clear Search</button>
        </span>
      </div>
  );
}

function Confirm ({prompt, done, cancel, listenKey, clearKeyListeners}) {
  function doDone () {
    clearKeyListeners();
    done();
  }

  function doCancel () {
    clearKeyListeners();
    cancel();
  }

  useEffect(() => {
    listenKey(doCancel, ['Escape', 'n']);
    listenKey(doDone, ['Enter', ' ', 'y']);
  });

  return (
    <div>
      <span style={{fontSize:'18pt'}}>{prompt} </span>
      <span>
        <button style={{margin:'10px', padding:'20px', width:'10vw'}} onClick={doDone}>Yes</button>
        <button style={{margin:'10px', padding:'20px', width:'10vw'}} onClick={doCancel}>No</button>
      </span>
    </div>
  );
}

function Prompt ({prompt, initialValue, done, cancel, listenKey, clearKeyListeners}) {

  const [value, setValue] = useState(initialValue);

  function doDone () {
    clearKeyListeners();
    done(value);
  }

  function doCancel () {
    clearKeyListeners();
    cancel();
  }

  useEffect(() => {
    listenKey(doCancel, ['Escape']);
    listenKey(doDone, ['Enter']);
  });

  return (
    <div>
      { false && 
        <span style={{fontSize:'18pt'}}>{prompt} </span>
      }
      <span>
        <textarea rows={5} autoFocus={true} value={value} onChange={e => setValue(e.target.value)} style={{width:'90vw', height:'35vh', fontSize:'18pt'}}>
          {value}
        </textarea>
        <br />
        <button style={{margin:'10px', padding:'20px', width:'30vw'}} onClick={() => doDone(value)}>Continue</button>
        <button style={{margin:'10px', padding:'20px', width:'30vw'}} onClick={doCancel}>Cancel</button>
      </span>
    </div>
  );
}

function QuickieSelector ({quickie, setQuickie, setQuickieTarget}) {
  const pickingTarget = useBool(false);
  const style = { 
    width: '12vw',
    minWidth: '12vw',
    height: '14vh',
    minHeight: '14vh',
    padding: 0,
    cursor: 'pointer',
    //display: 'inline-block',
    verticalAlign: 'middle', 
    display: 'table-cell', 
  };
  const selectedStyle = {
    ...style,
    backgroundColor: '#776666',
  };

  function setMove () {
    if (quickie === 'move') {
      setQuickie(null);
    }
    else {
      pickingTarget.on();  
    }
  }

  function selectedTarget (target) {
    setQuickie('move');
    setQuickieTarget(target);
    pickingTarget.off();
  }

  function cancelPickingTarget () {
    pickingTarget.off();
  }

  if (pickingTarget.value) {
    return (
      <MoveEntry entry={null} cancel={cancelPickingTarget} select={selectedTarget} />
    );
  }

  return (
    <div style={{backgroundColor:'green', paddingTop:'10px', paddingBottom:'10px'}}>
    <div style={{width:'100vw', height:'14vh', minHeight:'14vh', textAlign:'center', padding:0}}>
        <span style={quickie === "pri1" ? selectedStyle : style} className="actionBtn hoverHighlight" onClick={() => setQuickie('pri1')}><LooksOneIcon fontSize="large" /> (cmd-1)</span>
        <span style={quickie === "pri2" ? selectedStyle : style} className="actionBtn hoverHighlight" onClick={() => setQuickie('pri2')}><LooksTwoIcon fontSize="large" /> (cmd-2)</span>
        <span style={quickie === "pri3" ? selectedStyle : style} className="actionBtn hoverHighlight" onClick={() => setQuickie('pri3')}><Looks3Icon fontSize="large" /> (cmd-3)</span>
        <span style={quickie === "pri4" ? selectedStyle : style} className="actionBtn hoverHighlight" onClick={() => setQuickie('pri4')}><Looks4Icon fontSize="large" /> (cmd-4)</span>
        <span style={quickie === "pri5" ? selectedStyle : style} className="actionBtn hoverHighlight" onClick={() => setQuickie('pri5')}><Looks5Icon fontSize="large" /> (cmd-5)</span>
        <span style={quickie === "prix" ? selectedStyle : style} className="actionBtn hoverHighlight" onClick={() => setQuickie('prix')}><TimerOffIcon fontSize="large" /> (cmd-0)</span>
    </div>
    <div style={{width:'100vw', height:'14vh', minHeight:'14vh', textAlign:'center', padding:0}}>
        <span style={quickie === "move" ? selectedStyle : style} className="actionBtn hoverHighlight" onClick={setMove}><FolderIcon fontSize="large" /> (cmd-m)</span>
        <span style={quickie === "complete" ? selectedStyle : style} className="actionBtn hoverHighlight" onClick={() => setQuickie('complete')}><DoneIcon fontSize="large" /> (cmd-c)</span>
        <span style={quickie === "delete" ? selectedStyle : style} className="actionBtn hoverHighlight" onClick={() => setQuickie('delete')}><DeleteIcon fontSize="large" /> (cmd-d)</span>
    </div>
    </div>
  );
}

function TimeframeSelector ({timeframe, setTimeframe}) {
    const style = {
        width: '15vw',
        minWidth: '15vh',
        paddingTop: '1vh',
        paddingBottom: '1vh',
        cursor: 'pointer',
        display: 'inline-block',
        textAlign: 'center',
        verticalAlign: 'middle',
        paddingLeft: '1vw',
        paddingRight: '1vw',
        border: '1px solid white',
        height: '14vh',
        minHeight: '14vh',
        padding: 0,
    };
    const activeStyle = {
        ...style,
        backgroundColor: '#776666',
    };
    return (
        <div style={{width:'100vw', marginBottom:'2px', paddingTop:'10px', paddingBottom:'10px', backgroundColor:'#333333', textAlign:'center'}}>
        <span style={timeframe === 1 ? activeStyle : style} onClick={() => setTimeframe(1)}><LooksOneIcon fontSize="large" /> (1)</span>
        <span style={timeframe === 2 ? activeStyle : style} onClick={() => setTimeframe(2)}><LooksTwoIcon fontSize="large" /> (2)</span>
        <span style={timeframe === 3 ? activeStyle : style} onClick={() => setTimeframe(3)}><Looks3Icon fontSize="large" /> (3)</span>
        <span style={timeframe === 4 ? activeStyle : style} onClick={() => setTimeframe(4)}><Looks4Icon fontSize="large" /> (4)</span>
        <span style={timeframe === 5 ? activeStyle : style} onClick={() => setTimeframe(5)}><Looks5Icon fontSize="large" /> (5)</span>
        </div>
    );
}

function MoveEntry ({entry, cancel, select, forTextImport}) {
  const [entries, setEntries] = useState(null);
  const [loading, setLoading] = useState(false);
  const [chain, setChain] = useState([null]);
  const [moveTarget, setMoveTarget] = useState(null);
  const [moveTargetRoot, setMoveTargetRoot] = useState(false);
  const [recentTargets, setRecentTargets] = useState(null);

  async function load (parent = null) {
    setLoading(true);
    setEntries(null);
    let url = '/entry/get/';
    if (parent) {
      url += (parent.id) ? parent.id : parent;
    }
    let res = await get(url);
    res.sort((a,b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    setEntries(res);
    setLoading(false);
  }
  async function loadTargets () {
    let res = await get('/entry/targets'); 
    setRecentTargets(res);
    return (res);
  }
  async function init () { 
    let targets = await loadTargets();
    let chain = targets[0].chain;
    let pieces = chain.split('.');
    pieces.pop();
    pieces.pop();
    let parent = pieces[pieces.length - 1];
    setChain(pieces);
    await load(parent);
  }
  useEffect(() => {
    init();
  }, []);

  async function enter (entry) {
    setChain([...chain, entry]);
    await load(entry);
  }

  async function root () {
    setChain([]);
    await load();
  }

  async function up () {
    let newChain = [...chain];
    newChain.splice(-1);
    setChain(newChain);
    await load(newChain[newChain.length - 1]);
  }

  async function move (target) {
    if (!entry) {
      select(target);
    }
    else {
      setMoveTarget(target);
      await get('/entry/move/' + entry.id + '/' + target.id);
      select(target);  
    }
  }

  async function moveRoot () {
    if (!entry) {
      select(null);
    }
    else {
      setMoveTargetRoot(true);
      await get('/entry/move/' + entry.id + '/root');
      select(null);  
    }
  }

  async function moveHere () { 
    let lastChainPiece = chain[chain.length - 1];
    let target = lastChainPiece.id ? lastChainPiece : {id:lastChainPiece};
    setMoveTarget(target);
    await get('/entry/move/' + entry.id + '/' + target.id);
    select(target);
  }

  if (moveTargetRoot) {
    return (<div>now moving {entry.id} to root</div>);
  }

  if (moveTarget) {
    return (<div>now moving {entry.id} to {moveTarget.id}</div>);
  }

  return (
    <table style={{width:'100vw'}}><tbody><tr style={{verticalAlign:'top'}}>

    <td style={{maxWidth:'50vw'}}>
      { !forTextImport && entry && <h3>Move Entry '{entry.name}':</h3> }
      { !forTextImport && !entry && <h3>Pick Move Quickie Target:</h3> }
      { forTextImport && <h3>Pick Text Import Target:</h3> }
      <button style={{padding:'10px', marginBottom:'10px'}} onClick={cancel}>Cancel</button>
      <button style={{padding:'10px', marginLeft:'50px'}} onClick={moveRoot}>Pick Root</button>
      <button style={{padding:'10px', marginLeft:'50px'}} onClick={moveHere}>Pick Here</button>
      { loading && <div>Loading...</div> }
      { (entries && !entries.length) && <div>No entries</div> }

      <table style={{width:'50vw'}}><tbody>
      { (chain.length < 1) ? null :
        <tr style={{height:'5vh', backgroundColor:'#333333'}}>
            <td style={{textAlign:'center', width:'10vw'}}></td>
            <td onClick={root}>(root)</td>
        </tr>
      }
      { (chain.length < 1) ? null :
        <tr style={{height:'5vh', backgroundColor:'#333333'}}>
            <td style={{textAlign:'center', width:'10vw'}}></td>
            <td onClick={up}>(up)</td>
        </tr>
      }
      { (entries && entries.length) && entries.map((entry, i) =>
        <tr key={i} style={{height:'5vh', backgroundColor:(i % 2 === 0 ? '#222222' : '#333333')}}>
          <td style={{textAlign:'center', width:'10vw'}} onClick={() => move(entry)}><button style={{padding:'15px'}}>Select</button></td>
          <td onClick={(Number(entry.num_leaf_children) === 0 && Number(entry.num_nonleaf_children) === 0) ? null : (() => enter(entry))}>{entry.name}</td>
        </tr>
      )}
      { (chain.length < 2) ? null :
        <tr style={{height:'5vh', backgroundColor:'#333333'}}>
            <td style={{textAlign:'center', width:'10vw'}}></td>
            <td onClick={up}>(up)</td>
        </tr>
      }
      </tbody></table>

      <button style={{padding:'10px', marginTop:'10px'}} onClick={cancel}>Cancel</button>
    </td>

    <td style={{width:'50vw'}}>
      <h3>Recent Targets:</h3>
      { !recentTargets && <div>Loading...</div> }
      { (recentTargets && !recentTargets.length) && <div>No recent targets</div> }
      { (recentTargets && recentTargets.length) &&
        <table style={{width:'50vw'}}><tbody>
        { recentTargets.map((entry, i) =>
          <tr key={i} style={{height:'5vh', backgroundColor:(i % 2 === 0 ? '#222222' : '#333333')}}>
            <td style={{textAlign:'center', width:'10vw'}} onClick={() => move(entry)}><button style={{padding:'15px'}}>Select</button></td>
            <td onClick={(Number(entry.num_leaf_children) === 0 && Number(entry.num_nonleaf_children) === 0) ? null : (() => enter(entry))}>{entry.name}</td>
          </tr>
        )}
        </tbody></table>
      }
    </td>

    </tr></tbody></table>
  );
}

let maxApiCallIndex = 0;

export default function EntryList ({listenKey, clearKeyListeners}) {

    const [entries, setEntries] = useState(null);
    const [loading, setLoading] = useState(false);
    const [timeframe, setTimeframe] = useState(0);
    const [quickie, setQuickie] = useState(null);
    const [quickieTarget, setQuickieTarget] = useState(null);
    const [search, setSearch] = useState('');
    const [showActions, setShowActions] = useState(false);
    const [isStartingMoveQuickie, setIsStartingMoveQuickie] = useState(false);
    const [isMoving, setIsMoving] = useState(false);
    const [target, setTarget] = useState(null);
    const [isEditingSearch, setIsEditingSearch] = useState(false);
    const [isAskingConfirm, setIsAskingConfirm] = useState(false);
    const [delTarget, setDelTarget] = useState(null);
    const [isAddingEntry, setIsAddingEntry] = useState(false);
    const [addEntryParent, setAddEntryParent] = useState(null);
    const [addEntryChildFlag, setAddEntryChildFlag] = useState(null);
    const [isEditingEntry, setIsEditingEntry] = useState(false);
    const [editEntryTarget, setEditEntryTarget] = useState(null);
    const [currHoverEntry, setCurrHoverEntry] = useState(null);
    const [isPickingImportTarget, setIsPickingImportTarget] = useState(false);
    const [importTarget, setImportTarget] = useState(null);
    const [importText, setImportText] = useState('');
    const [importPri, setImportPri] = useState(null);
    const [showingShortcuts, setShowingShortcuts] = useState(false);
    const [copyingToClipboard, setCopyingToClipboard] = useState(null);

    function moveEntrySelection (delta) {
    }

    function CollapseEntry () {
    }

    function ExpandEntry () {
    }

    function autoExpand (entries) {
      for (let i=0; i<entries.length; i++) {
        entries[i].expanded = '1';
        if (entries[i].children) {
          autoExpand(entries[i].children);
        }
      }
    }

    function attachAndSet (parent, children) {
        if (!parent) {
          if (timeframe) {
            autoExpand(children);
          }
          setEntries(clone(children));
        } else {
          parent.loadingChildren = false;
          parent.children = children;
          setEntries(clone(entries));
        }
        setLoading(false);
      }

        async function load (parent = null, event = null) {

          setEntries([]);

          // manage api call counter
          let currApiCallIndex = maxApiCallIndex++;

          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }

          if (parent && parent.showActions) {
            toggleActions(parent);
          }
      
          if (parent && parent.expanded === '1') {
            parent.expanded = '0';
            if (currApiCallIndex === maxApiCallIndex - 1) {
              setEntries(clone(entries));
            }
            await get('/entry/expand/' + parent.id + '/0');
            return;
          }

          if (parent && parent.children && parent.expanded === '0') {
            parent.expanded = '1';
            await get('/entry/expand/' + parent.id + '/1');
            if (currApiCallIndex === maxApiCallIndex - 1) {
              setEntries(clone(entries));
            }
            return;
          }

          if (!entries) {
            setLoading(true);
          }
          if (parent) {
            parent.loadingChildren = true;
            setEntries(clone(entries));
            await get('/entry/expand/' + parent.id + '/1');
          }
          let url = '/entry/get/';
          if (parent) {
            parent.expanded = '1';
            url += parent.id;
          }
          else {
            url += '?timeframe=' + timeframe;
            if (search && search.trim() !== '') {
              url += '&search=' + encodeURIComponent(search.trim());
            }
          }
          let children = await get(url);

          // expand everything that came back if a timeframe filter is active
          if (timeframe) {
            for (let i=0; i<children.length; i++) {
              children[i].expanded = '1';
            }
          }

          // sort alphabetically and recurse for children
          if (currApiCallIndex === maxApiCallIndex - 1) {
            children.sort((a,b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            attachAndSet(parent, children);  
          }
        }

      function timeFrameShortcut (num) {
        if (timeframe === num) {
          setTimeframe(null);
        }
        else {
          setTimeframe(num);
        }
      }

      function quickieShortcut (newQuickie) {
        if (quickie !== newQuickie) {
          setQuickie(newQuickie);
        }
        else {
          setQuickie(null);
        }
      }

      async function collapseAll () {
        await get('/entry/collapse_all');
        await load();
      }

      async function expandAll () {
        //ega recurse through all in current view and expand all when able to, do api calls for all
        //ega refresh view
      }

      function setKeyListeners () {
        if (!isEditingSearch && !isAskingConfirm && !isAddingEntry && !isEditingEntry) {

          // find shortcuts
          listenKey(() => editSearch(search), ['f']);
          listenKey(clearSearch, ['f'], true);

          // refresh
          listenKey(load, ['r']); 

          // menu shortcut
          listenKey(() => setShowActions(!showActions), ['Escape']);
  
          // expand/collapse shortcuts
          listenKey(collapseAll, [','], true);
          listenKey(expandAll, ['.'], true);

          // navigation shortcuts
          listenKey(() => moveEntrySelection(-1), ['ArrowUp']);
          listenKey(() => moveEntrySelection(+1), ['ArrowDown']);
          listenKey(() => CollapseEntry(), ['ArrowLeft']);
          listenKey(() => ExpandEntry(), ['ArrowRight']);
  
          // global action shortcuts
          listenKey(AddRootEntry, ['z']);

          // context action shortcuts
          listenKey(contextCopy, ['c']);
          listenKey(contextDelete, ['d']);  
          listenKey(contextAddChild, ['a']);
          listenKey(contextMove, ['m']);
          listenKey(contextEdit, ['e']);
          listenKey(contextQuickie, ['q']);
          listenKey(contextMoveQuickie, ['t']); 
          listenKey(cancelMoveQuickie, ['t'], true);

          // view shortcuts
          listenKey(() => timeFrameShortcut(1), ['1']);
          listenKey(() => timeFrameShortcut(2), ['2']);
          listenKey(() => timeFrameShortcut(3), ['3']);
          listenKey(() => timeFrameShortcut(4), ['4']);
          listenKey(() => timeFrameShortcut(5), ['5']);
  
          // quickie shortcuts
          listenKey(() => quickieShortcut('pri1'), ['1'], true);
          listenKey(() => quickieShortcut('pri2'), ['2'], true);
          listenKey(() => quickieShortcut('pri3'), ['3'], true);
          listenKey(() => quickieShortcut('pri4'), ['4'], true);
          listenKey(() => quickieShortcut('pri5'), ['5'], true);
          listenKey(() => quickieShortcut('prix'), ['0'], true);
          listenKey(startMoveQuickie, ['m'], true);
          listenKey(() => quickieShortcut('complete'), ['c'], true);
          listenKey(() => quickieShortcut('delete'), ['d'], true);  
        }
      }

      async function startMoveQuickie () {
        if (quickie === 'move') {
          setQuickie(null);
        }
        else {
          setIsStartingMoveQuickie(true);
        }
      }

      async function completeMoveQuickie (targetParam) {
        setQuickieTarget(targetParam);
        quickieShortcut('move');
        setIsStartingMoveQuickie(false);
      }

      async function contextQuickie () {
        if (quickie === 'delete') {
          await del(currHoverEntry, null, false);
        }
        else if (quickie === 'complete') {
            await complete(currHoverEntry, null);
        }
        else if (quickie && quickie.includes('pri')) {
            await assignTimeframe(currHoverEntry, (quickie === 'prix') ? null : Number(quickie.substring(3)), null);
        }
        else if (quickie && quickie.includes('move')) {
            await moveQuickie(currHoverEntry, null);
        }
      }

      async function contextEdit () {
        if (currHoverEntry) {
          await edit (currHoverEntry, null);
        }
      }

      async function contextMove () {
        if (currHoverEntry) {
          await move (currHoverEntry, null);
        }
      }

      async function contextMoveQuickie () { 
        if (currHoverEntry) {
          setQuickieTarget(currHoverEntry);
          setQuickie('move');
        }  
      }

      function cancelMoveQuickie () {
        setQuickie(null);
      }

      async function contextAddChild () {
        if (currHoverEntry) {
          await add(currHoverEntry, true, null);
        }
      }

      async function contextCopy () {
        if (currHoverEntry) {
            setCopyingToClipboard(Number(currHoverEntry.id));
            setTimeout(() => setCopyingToClipboard(null), 500);
            const textarea = document.createElement("textarea");
            textarea.value = currHoverEntry.name;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy"); // legacy API
            document.body.removeChild(textarea);
            //navigator.clipboard.writeText(currHoverEntry.name); // old code that didn't work when deployed to non https server
        }
      }

      async function contextDelete () {
        if (currHoverEntry) {
          await del (currHoverEntry);
          setCurrHoverEntry(null);
        }
      }

      useEffect(() => {load()}, [timeframe, search]);
      useEffect(setKeyListeners);

      function editSearch (search) {
        clearKeyListeners();
        setIsEditingSearch(true);
      }

      function didEditSearch (searchFor) {
        setSearch(searchFor);
        setIsEditingSearch(false);
        setKeyListeners();
      }

      function cancelEditSearch () {
        setIsEditingSearch(false);
        setKeyListeners();
      }

      async function clearSearch () {
        setSearch('');
      }

      async function AddRootEntry () {
        await add (null, false, null);
      }

      async function del (entry, event = null, askConfirm = true) {
        if (askConfirm) {
          clearKeyListeners();
          setIsAskingConfirm(true);
          setDelTarget(entry);
        }
        else {
          await delDone(entry);
        }
      }
  
      async function delDone (entry) {
        setEntries(clone(tree.walk(entries, (n, {modify}) => {
          if (n.id === entry.id) {
            modify({
              ...n,
              pending: true,
            });
          }
        })));
        await get('/entry/delete/' + entry.id);
        setEntries(clone(tree.walk(entries, (n, {del, stop}) => {
          if (n.id === entry.id) {
            del();
            stop();
          }
        })));
        setIsAskingConfirm(false);
      }

      async function add (entry, childFlag, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();  
        }

        clearKeyListeners();
        setIsAddingEntry(true);
        setAddEntryParent(entry);
        setAddEntryChildFlag(childFlag);
      }

      async function didAdd (name) {
        if (name) {
          name = name.trim();
        }
        if (name && name.length) {
          let url;
          if (addEntryParent) {
            url = '/entry/create' + (addEntryChildFlag ? 'Child' : 'Sibling') + '/' + addEntryParent.id + '?name=' + encodeURIComponent(name);
          }
          else {
            url = '/entry/createRoot?name=' + encodeURIComponent(name);
          }
          let newEntry = await get(url);
          if (addEntryParent) {
            setEntries(clone(tree.walk(entries, (n, {insertAfter, insertChild, stop}) => {
              if (n.id === addEntryParent.id) {
                const insert = addEntryChildFlag ? insertChild : insertAfter;
                insert(newEntry);
                stop();
              }
            })));  
          }
          else {
            setEntries(clone(tree.walk(entries, (n, {insertAfter, stop}) => {
              insertAfter(newEntry);
              stop();
            })));  
          }
        }
        setIsAddingEntry(false);
        setKeyListeners();
      }

      function cancelAddingEntry () {
        setIsAddingEntry(false);
        setKeyListeners();
      }

      function cancelEditingEntry () {
        setIsEditingEntry(false);
        setKeyListeners();
      }

      async function complete (entry, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();  
        }
        setEntries(clone(tree.walk(entries, (n, {modify}) => {
          if (n.id === entry.id) {
            modify({
              ...n,
              pending: true,
            });
          }
        })));
        let url = '/entry/complete/' + entry.id;
        await get(url);
        setEntries(clone(tree.walk(entries, (n, {del, stop}) => {
          if (n.id === entry.id) {
            del();
            stop();
          }
        })));
      }

      async function move (entry, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();  
        }
        setIsMoving(true);
        setTarget(entry);
      }

      async function moveQuickie (entry, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();  
        }
        if (quickieTarget) {
          await get('/entry/move/' + entry.id + '/' + quickieTarget.id);
        }
        else {
          await get('/entry/move/' + entry.id + '/root');
        }
        load();
      }

      async function edit (entry, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();  
        }
        clearKeyListeners();
        setIsEditingEntry(true);
        setEditEntryTarget(entry);
      }

      async function didEdit (name) {
        if (name && name.trim().length) {
          let url = '/entry/edit/' + editEntryTarget.id + '?name=' + encodeURIComponent(name);
          let newEntry = await get(url);
          setEntries(clone(tree.walk(entries, (n, {modify, stop}) => {
            if (n.id === editEntryTarget.id) {
              modify(newEntry);
              stop();
            }
          })));
        }
        setIsEditingEntry(false);
        setKeyListeners();
      }
    
      async function assignTimeframe (entry, level, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();  
        }
        let url = '/entry/timeframe/' + entry.id + '?timeframe=' + level;
        setEntries(clone(tree.walk(entries, (n, {modify}) => {
          if (n.id === entry.id) {
            modify({
              ...n,
              pending: true,
            });
          }
        })));
        await get(url);
        setEntries(clone(tree.walk(entries, (n, {modify}) => {
          if (n.id === entry.id) {
            modify({
              ...n,
              pending: false,
            });
          }
        })));
      }

      function toggleActions (entry, event = null) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();  
        }
        setEntries(clone(tree.walk(entries, (n, {modify, stop}) => {
          if (n.id === entry.id) {
            let showActions = n.showActions ? false : true;
            modify({
              ...n,
              showActions,
            });
          } else if (n.showActions) {
            modify({
              ...n,
              showActions: false,
            });
          }
        })));
      }
    
      function handleSetTimeframe (newTimeframe) {
        setTimeframe(timeframe === newTimeframe ? null : newTimeframe);
      }

      let menuStyle = { 
        cursor: 'pointer',
        //position: '-webkit-sticky',
        position: 'sticky', 
        backgroundColor:'#33373b',
        zIndex: 10,
        top: 0,
      };
      if (showActions) {
        menuStyle = {
          ...menuStyle,
          height:'14vh', 
          minHeight:'14vh',
          padding: 0,
        };
      }

      function handleSetQuickie (type) {
        if (type === quickie) {
          setQuickie(null);
        }
        else {
          setQuickie(type);
        }
      }

      function selectMove (entry) {
        setIsMoving(false);
        load();
      }

      function cancelAskingConfirm () {
        setIsAskingConfirm(false);
        setKeyListeners();
      }

      function pickedImportTarget (target) {
        setImportTarget(target);
        setIsPickingImportTarget(false);
      }

      if (isEditingEntry) {
        return (
          <Prompt 
            prompt="Description:"
            initialValue={editEntryTarget.name} 
            done={didEdit}
            cancel={cancelEditingEntry}
            listenKey={listenKey} 
            clearKeyListeners={clearKeyListeners} 
          />);
      }
      if (isAddingEntry) {
        return (
          <Prompt 
            prompt={addEntryParent ? (addEntryChildFlag ? "Create child entry:" : "Create sibling entry:") : "Create root entry:"}
            initialValue={""} 
            done={didAdd}
            cancel={cancelAddingEntry}
            listenKey={listenKey} 
            clearKeyListeners={clearKeyListeners} 
          />);
      }
      if (isAskingConfirm) {
        return (<Confirm prompt="Are you sure?" done={() => delDone(delTarget)} cancel={cancelAskingConfirm} listenKey={listenKey} clearKeyListeners={clearKeyListeners} />);
      }
      if (isEditingSearch) {
        return (<Prompt prompt="Search for:" initialValue={search} done={didEditSearch} cancel={cancelEditSearch} listenKey={listenKey} clearKeyListeners={clearKeyListeners} />);
      }
      if (isStartingMoveQuickie) {
        return (<MoveEntry entry={null} cancel={() => setIsStartingMoveQuickie(false)} select={completeMoveQuickie} />);
      }
      if (isMoving) {
        return (<MoveEntry entry={target} cancel={() => setIsMoving(false)} select={selectMove} />);
      }
      let stateStr = <span> {timeframe !== 0 ? timeframe : null} {quickie} {(quickie === 'move' && quickieTarget) ? (' to ' + quickieTarget.name) : null} {search ? ("'" + search + "'") : null} </span>; 
      if (!showActions) {
        return (
          <>
                <div onClick={() => setShowActions(!showActions)} className="entry-container" style={menuStyle}>
                    <table style={{margin:0, padding:0, width:'100vw', blahposition:'fixed', tableLayout:'fixed'}}><tbody><tr>
                        <td style={{textAlign:'center'}}>open menu (esc) {stateStr}</td>
                    </tr></tbody></table>
                </div>
                { loading && <p>Loading...</p> }
                { !loading && entries && !entries.length && <p>(empty list)</p> }
                { !loading && entries && entries.map((entry, i) =>
                  <Entry 
                    key={i} 
                    entry={entry} 
                    toggle={load} 
                    toggleActions={toggleActions} 
                    quickie={quickie} 
                    quickieTarget={quickieTarget} 
                    add={add} 
                    del={del} 
                    complete={complete} 
                    edit={edit} 
                    move={move} 
                    moveQuickie={moveQuickie} 
                    timeframe={assignTimeframe}
                    setCurrHoverEntry={setCurrHoverEntry}
                    copyingToClipboard={copyingToClipboard}
                  />
                )}
          </> 
        );  
      }
      else {
        if (isPickingImportTarget) {
          return (<MoveEntry forTextImport={true} cancel={() => setIsPickingImportTarget(false)} select={pickedImportTarget} />);
        }
        if (showingShortcuts) {
          return (
            <>

            <table>

              <tr style={{fontWeight:'bold', textDecoration:'underline'}}><td style={{paddingTop:'20px'}} colspan="2">General</td></tr>
              <tr><td> Escape / n </td><td> Cancel </td></tr>
              <tr><td> Enter / y </td><td> Confirm </td></tr>

              <tr style={{fontWeight:'bold', textDecoration:'underline'}}><td style={{paddingTop:'20px'}} colspan="2">Search</td></tr>
              <tr><td> f </td><td> Search </td></tr>
              <tr><td> cmd-f </td><td> Clear search </td></tr>

              <tr style={{fontWeight:'bold', textDecoration:'underline'}}><td style={{paddingTop:'20px'}} colspan="2">Menu</td></tr>
              <tr><td> esc </td><td> Toggle menu </td></tr>

              <tr style={{fontWeight:'bold', textDecoration:'underline'}}><td style={{paddingTop:'20px'}} colspan="2">Expand/Collapse</td></tr>
              <tr><td> cmd-, </td><td> Collapse all </td></tr>
              <tr><td> cmd-. </td><td> Expand all </td></tr>
              <tr><td> left </td><td> Collapse </td></tr>
              <tr><td> right </td><td> Expand </td></tr>

              <tr style={{fontWeight:'bold', textDecoration:'underline'}}><td style={{paddingTop:'20px'}} colspan="2">Navigation</td></tr>
              <tr><td> up </td><td> Up </td></tr>
              <tr><td> down </td><td> Down </td></tr>

              <tr style={{fontWeight:'bold', textDecoration:'underline'}}><td style={{paddingTop:'20px'}} colspan="2">Global Actions</td></tr>
              <tr><td> z </td><td> Add root entry </td></tr>

              <tr style={{fontWeight:'bold', textDecoration:'underline'}}><td style={{paddingTop:'20px'}} colspan="2">Context Actions</td></tr>
              <tr><td> c </td><td> Copy </td></tr>
              <tr><td> d </td><td> Delete </td></tr>
              <tr><td> a </td><td> Add child </td></tr>
              <tr><td> m </td><td> Move </td></tr>
              <tr><td> e </td><td> Edit </td></tr>
              <tr><td> q </td><td> Quickie </td></tr>
              <tr><td> t </td><td> Move quickie </td></tr>

              <tr style={{fontWeight:'bold', textDecoration:'underline'}}><td style={{paddingTop:'20px'}} colspan="2">View</td></tr>
              <tr><td> 1-5 </td><td> Toggle priority 1-5 </td></tr>
              <tr><td> r </td><td> Refresh view </td></tr>

              <tr style={{fontWeight:'bold', textDecoration:'underline'}}><td style={{paddingTop:'20px'}} colspan="2">Quickie shortcuts</td></tr>
              <tr><td> cmd-(1-5) </td><td> Set priority 1-5 </td></tr>
              <tr><td> cmd-0 </td><td> Clear priority </td></tr>
              <tr><td> cmd-m </td><td> Move </td></tr>
              <tr><td> cmd-c </td><td> Complete </td></tr>
              <tr><td> cmd-d </td><td> Delete </td></tr>

            </table>

              <button style={{marginTop:'20px', width:'25vw', height:'50px'}} onClick={() => setShowingShortcuts(false)}>back</button>
            </>
          );
        }
        return (
          <>
                <div className="entry-container" style={menuStyle} onClick={() => setShowActions(!showActions)}>
                    <table style={{margin:0, padding:0, width:'100vw', blahposition:'fixed', tableLayout:'fixed'}}><tbody><tr>
                        <td style={{textAlign:'center'}}>close menu (esc)</td>
                    </tr></tbody></table>
                </div>
                <SearchBar search={search} editSearch={editSearch} clearSearch={clearSearch} />
                <TimeframeSelector timeframe={timeframe} setTimeframe={handleSetTimeframe} />
                <QuickieSelector quickie={quickie} setQuickie={handleSetQuickie} setQuickieTarget={setQuickieTarget} />
                <Import 
                  importTarget={importTarget} 
                  pickImportTarget={() => setIsPickingImportTarget(true)} 
                  importText={importText}
                  setImportText={setImportText}
                  importPri={importPri}
                  setImportPri={setImportPri}        
                  setShowingShortcuts={() => setShowingShortcuts(true)}
                />
                <Settings />
          </> 
        );
      }

}